import { render, staticRenderFns } from "./AppShowcaseNewsletter.vue?vue&type=template&id=cfb8571c&"
import script from "./AppShowcaseNewsletter.vue?vue&type=script&lang=js&"
export * from "./AppShowcaseNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports